export default "__VITE_ASSET__DiEHb8u2__"